<template>
	<div class="modal" :class="isOpenProp ? 'modal--open' : ''">
		<div class="modal__cover"></div>
		<div class="modal__window">
			<button class="modal__close" @click="close">×</button>
			<div v-html="copyProp"></div>
			<button class="modal__action button button--primary" @click="close">OK</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['copyProp', 'isOpenProp'],
		data() {
			return {};
		},
		methods: {
			close: function() {
				this.$emit('disclaimerClosed', null);
			}
		},
	};
</script>

<style scoped>
	.modal {
		display: none;
		position: absolute;
	}

	.modal--open {
		display: block;
	}

	.modal__cover {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(255,255,255,0.8);
		width: 100%;
		height: 100%;
	}

	.modal__window {
		width: 75%;
		max-width: 750px;
		max-height: 80vh;
		overflow-y: scroll;
		padding: 2em;
		background: #fff;
		color: #000;
		text-align: center;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0 0 30px rgb(0 0 0 / 40%);
	}

	.modal__close {
		background: none;
		border: none;
		position: absolute;
		top: 5px;
		right: 5px;
		cursor: pointer;
	}

	.modal__action {

	}
</style>